import {
  createFrontendPlugin,
  ApiBlueprint,
  PageBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { sparkApiRef } from './api/sparkApi';
import { R2HostingClient } from './api/R2HostingApi';
import { rootRouteRef } from './routes';

const clientDeps = {
  discoveryApi: discoveryApiRef,
  fetchApi: fetchApiRef,
};

function createClient(deps: {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
}) {
  return new R2HostingClient(deps.discoveryApi, deps.fetchApi);
}

const sparkApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: sparkApiRef,
      deps: clientDeps,
      factory: createClient,
    }),
});

const sparkPage = PageBlueprint.make({
  params: {
    path: '/spark',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/SparkRoutes').then(m => <m.SparkRoutes />),
  },
});

export const sparkPlugin = createFrontendPlugin({
  pluginId: 'spark',
  routes: { root: rootRouteRef },
  extensions: [sparkApi, sparkPage],
});
